import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import DownloadPage from './DownloadPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/terms" element={<iframe src="/termsandconditions.html" title="Terms and Conditions" style={{ width: '100%', height: '100vh', border: 'none' }} />} />
        <Route path="/privacy" element={<iframe src="/privacypolicy.html" title="Privacy Policy" style={{ width: '100%', height: '100vh', border: 'none' }} />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
